import { render } from "./HeaderNav.vue?vue&type=template&id=34c60d26"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\pwa-tahlil\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__